import { TableContainer } from "./Components";


export default function TableRow({children, onClick}){
    return (
        <tr onClick={onClick} className={onClick && "tr-link"}>
            {children}
        </tr>
    )
}